import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatUrlForBackgroundImagePipe',
  standalone: false,
})
export class FormatUrlForBackgroundImagePipe implements PipeTransform {
  transform(url: string, width: string, height: string): string {
    return `url(${url})`.replace('w=%d', `w=${width}`).replace('h=%d', `h=${height}`);
  }
}
